import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { usePaymentsChartsContext } from './hooks/usePaymentsChartsContext';

export const PaymentsYearAvg = () => {
    const { chartData } = usePaymentsChartsContext();

    const rawData = chartData?.paymentsYear || [];

    const series = [
        {
            name: 'Valor Médio',
            data: rawData.map((item) => item.avg_value || 0)
        }
    ];

    return (
        <SimpleBars
            title="Valor Médio - Anual"
            horizontal={false}
            subtitles={rawData.map((item) => getYearLabel(item.ano))}
            series={series}
            showDataLabels={false}
        />
    );
};
